import { Container } from "../../Container/Container/Container";
import { Text } from "../../Text/Text/Text";
import styles from "./FootnoteSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var FootnoteSlice = function FootnoteSlice(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_jsx("div", {
    className: styles.footnote,
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Text, {
        typog: "captionSmall",
        children: text
      })
    })
  });
};